// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid.show-all[data-v-57c96a84]{grid-template-columns:repeat(2,1fr)}.grid.show-all a[data-v-57c96a84]:nth-child(3n+1){grid-column-end:span 2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
